import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

export const StatisticsRow = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  margin-bottom: ${theme.spacing.sm};
  gap: ${theme.spacing.sm};
`
export const Item = styled.span`
 font-size: ${theme.typography.sizes['2xs']};
  color: ${theme.colors.neutral.medium};
  text-align: end;

  strong {
    font-family: ${theme.typography.family.bold};
    font-weight: ${theme.typography.weight.lg};
  }


@media only screen and (max-width: ${theme.breakpoints.md}px) {
  & {
    text-align: start;
  }`
